import { el } from 'redom';

import SingleSelectNative from 'generics/components/single-select/native';

import './index.scss';

var propertyOptions = [
  { label: 'Transform', value: 'transform' },
  { label: 'Opacity', value: 'opacity' },
  { label: 'Box Shadow', value: 'box-shadow' },
  { label: 'Background', value: 'background-color' },
  { label: 'Radius', value: 'border-radius' }
];

var easingOptions = [
  { label: 'Ease', value: 'ease' },
  { label: 'Ease In', value: 'ease-in' },
  { label: 'Ease Out', value: 'ease-out' },
  { label: 'Ease In Out', value: 'ease-in-out' },
  { label: 'Linear', value: 'linear' }
];

function getDefaultTransition() {

  var transition = {
    properties: [],
    durationMs: 300,
    easing: 'ease',
    delayMs: 0
  };

  return transition;

}

function getSelectedPropertyIndices(properties) {

  var indices = [];

  for (var i = 0; i < properties.length; i++) {

    var property = properties[i];

    for (var j = 0; j < propertyOptions.length; j++) {

      if (propertyOptions[j].value === property) {
        indices.push(j);
        break;
      }

    }

  }

  return indices;

}

function getSelectedEasingIndex(easing) {

  for (var i = 0; i < easingOptions.length; i++) {

    if (easingOptions[i].value === easing) {
      return i;
    }

  }

  return 0;

}

class TransitionInput {

  constructor(configuration) {

    this.onChange = configuration.onChange;

    var transition = configuration.transition;

    if (transition === void 0 || transition === null) {
      transition = getDefaultTransition();
    }

    this.transition = {
      properties: transition.properties || [],
      durationMs: transition.durationMs || 300,
      easing: transition.easing || 'ease',
      delayMs: transition.delayMs || 0
    };

    this.propertiesSelectContainer = el('.transition-input-field');
    this.easingSelectContainer = el('.transition-input-field');

    this.el = el('.transition-input-main', [
      this.renderPropertiesSelect(),
      this.renderDurationInput(),
      this.renderEasingSelect(),
      this.renderDelayInput()
    ]);

  }

  handlePropertiesChange(result) {
    this.transition.properties = result.values;
    this.propagateChange();
  }

  renderPropertiesSelect() {

    var selectedIndices = getSelectedPropertyIndices(this.transition.properties);

    var selectConfiguration = {
      placeholder: 'Properties',
      options: propertyOptions,
      selectedOptionIndices: selectedIndices,
      multiSelect: true,
      onChange: this.handlePropertiesChange.bind(this)
    };

    this.propertiesSelect = new SingleSelectNative(selectConfiguration);

    var fieldElement = el('.transition-input-field', [
      el('label.transition-input-label.field-label', 'Properties'),
      this.propertiesSelect
    ]);

    return fieldElement;

  }

  renderDurationInput() {

    var self = this;

    var inputAttributes = {
      type: 'number',
      min: 0,
      step: 50,
      value: this.transition.durationMs,
      oninput: function handleDurationInput(event) {
        var value = parseInt(event.target.value, 10);
        if (isNaN(value) === true) {
          value = 0;
        }
        self.transition.durationMs = value;
        self.propagateChange();
      }
    };

    this.durationInput = el('input.transition-number-input', inputAttributes);

    var fieldElement = el('.transition-input-field', [
      el('label.transition-input-label.field-label', 'Duration (ms)'),
      this.durationInput
    ]);

    return fieldElement;

  }

  renderEasingSelect() {

    var self = this;
    var selectedIndex = getSelectedEasingIndex(this.transition.easing);

    var selectConfiguration = {
      placeholder: 'Easing',
      options: easingOptions,
      selectedOptionIndices: [selectedIndex],
      multiSelect: false,
      onChange: function handleEasingChange(result) {
        var values = result.values;
        if (values.length > 0) {
          self.transition.easing = values[0];
        }
        self.propagateChange();
      }
    };

    this.easingSelect = new SingleSelectNative(selectConfiguration);

    var fieldElement = el('.transition-input-field', [
      el('label.transition-input-label.field-label', 'Timing'),
      this.easingSelect
    ]);

    return fieldElement;

  }

  renderDelayInput() {

    var self = this;

    var inputAttributes = {
      type: 'number',
      min: 0,
      step: 50,
      value: this.transition.delayMs,
      oninput: function handleDelayInput(event) {
        var value = parseInt(event.target.value, 10);
        if (isNaN(value) === true) {
          value = 0;
        }
        self.transition.delayMs = value;
        self.propagateChange();
      }
    };

    this.delayInput = el('input.transition-number-input', inputAttributes);

    var fieldElement = el('.transition-input-field', [
      el('label.transition-input-label.field-label', 'Delay (ms)'),
      this.delayInput
    ]);

    return fieldElement;

  }

  propagateChange() {

    var transition = {
      properties: this.transition.properties,
      durationMs: this.transition.durationMs,
      easing: this.transition.easing,
      delayMs: this.transition.delayMs
    };

    this.onChange(transition);

  }

  update(configuration) {

    var transition = configuration.transition;

    if (transition === void 0 || transition === null) {
      transition = getDefaultTransition();
    }

    this.transition = {
      properties: transition.properties || [],
      durationMs: transition.durationMs || 300,
      easing: transition.easing || 'ease',
      delayMs: transition.delayMs || 0
    };

    this.onChange = configuration.onChange;

    var selectedPropertyIndices = getSelectedPropertyIndices(this.transition.properties);
    this.propertiesSelect.configure({
      options: propertyOptions,
      selectedOptionIndices: selectedPropertyIndices,
      multiSelect: true,
      onChange: this.handlePropertiesChange.bind(this)
    });

    var selectedEasingIndex = getSelectedEasingIndex(this.transition.easing);
    this.easingSelect.configure({
      options: easingOptions,
      selectedOptionIndices: [selectedEasingIndex],
      multiSelect: false
    });

    this.durationInput.value = this.transition.durationMs;
    this.delayInput.value = this.transition.delayMs;

  }

}

export default TransitionInput;
export { getDefaultTransition };